<form class="form-horizontal" [formGroup]="formFileLocations" (ngSubmit)="upLoadFile()">
  <p-dialog
    header="Subir archivo"
    [(visible)]="displayDialog"
    showEffect="fade"
    [modal]="true"
    [draggable]="false"
    class="p-fluid"
    [style]="{ width: '30vw' }"
    [breakpoints]="{ '960px': '75vw', '640px': '100vw' }"
    (onHide)="close()"
  >
    <div class="field">
      <label for="sku_type_id"
        >{{ 'Tipo' | translate }} <span class="text-red">*</span></label
      >
      <p-autoComplete
          [suggestions]="(typeLocations$ | async)!"
          (completeMethod)="filterTypeLocations($event)"
          [minLength]="1"
          placeholder="{{ 'Buscar' | translate }}: "
          [dropdown]="true"
          formControlName="location_type_id"
          field="name"
          dataKey="id"
        >
        </p-autoComplete>
      <small
        class="ng-dirty ng-invalid"
        [hidden]="location_type_id?.valid || location_type_id?.pristine"
        >{{ 'Debe seleccionar un Tipo' | translate }}</small
      >
    </div>
    <div class="field">
      <kanzi-file-upload
        formControlName="master_file_location"
        [activeBtnSubmit]="false"
        [multiple]="false"
        [accept]="'*'"
      >
      </kanzi-file-upload>
    </div>
    <ng-template pTemplate="footer">
      <button
        pButton
        pRipple
        label="{{ 'Cancelar' | translate }}"
        icon="pi pi-times"
        class="p-button-text"
        type="button"
        (click)="close()"
      ></button>
      <button
        pButton
        pRipple
        label="{{ 'Guardar' | translate }}"
        icon="pi pi-check"
        class="p-button-text"
        [disabled]="!formFileLocations.valid"
        type="submit"
      ></button>
    </ng-template>
  </p-dialog>
</form>
